import { Footer } from "../../components/Footer";
import { Link } from "react-router-dom";

export const RefundPolicy = () => {
  return (
    <>
      {/* <!-- ======= Header ======= --> */}
      <header id="header" class="d-flex align-items-center header-transparent ">
        <div class="container d-flex align-items-start justify-content-between">
          <div class="logo">
            {/* <!-- <h1><a href="index.html"><span>Bootslander</span></a></h1> -->
        <!-- Uncomment below if you prefer to use an image logo --> */}
            <Link to="/">
              <img src="img/logo.png" alt="" class="img-fluid" />
            </Link>
          </div>

          {/* <nav id="navbar" class="navbar">
            <ul>
              <li>
                <a class="nav-link btn btn-primary scrollto" href="https://admin.mybattle11.com/downloads">
                  {" "}
                  <i class="ri-download-fill me-2"></i> Download App
                </a>
              </li>
            </ul>
          </nav> */}

          {/* <!-- .navbar --> */}
        </div>
      </header>
      {/* <!-- End Header --> */}

      <section class="inner_hero_sec">
        <div class="heading">
          <h1>   Cancellation/Refund Policy </h1>
        </div>
      </section>

      <main id="main">
        <section class="breadcrumbs">
          <div class="container">
            <div class="d-flex justify-content-between align-items-center">
              <ol>
                <li>
                  <a href="/">Home</a>
                </li>
                <li> Cancellation/Refund Policy </li>
              </ol>
            </div>
          </div>
        </section>
        {/* <!-- End Breadcrumbs Section --> */}

        <section class="inner-page">
          <div class="container">
            <div class="content">
              <h4 className="mb-3" ><b>Cancellation/Refund Policy</b></h4>

              <p>
               <b> 1.	</b> All transactions made by User on MyBattle11 Platform including deposits and withdrawals are final and no cancellations will be permissible.
              </p>
              <p>
              <b> 2.</b>	MyBattle11 Platform reserves the right to cancel any pool(s)/ match(es) for any reason, with or without disclosure of the reason, and refund all transactions paid for such pools/matches by any and all users within 3 business days by the original mode of payment used by the User for such transaction.
              </p>
              <p>
              <b>3.</b>	MyBattle11 Platform strives for customer satisfaction and in furtherance of the Terms & Conditions Policy the following exceptional circumstances allow for refunds:
              
              </p>
              <ul>
               <li>
               a)	Only force majeure or
               </li>
              <li>
              b)	Payment Gateway failure
              </li>
              </ul> 

              <p>
             <b> 4.</b>	For any Payment Gateway failure; the User must submit a request for review within 3 days of such transaction along with relevant proof to <a className="text-decoration-underline" href="mailto:support@mybattle11.com" >support@mybattle11.com</a>. The request shall be reviewed, and resolution (if applicable) will be provided to the User within 2 weeks of raising the request.

              </p>


             
            </div>
          </div>
        </section>
      </main>
      {/* <!-- End #main --> */}

      {/* <!-- ======= Footer ======= --> */}
      <Footer />
      {/* <!-- End Footer --> */}

      <a
        href="#"
        class="back-to-top d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-arrow-up-short"></i>
      </a>
      {/* <div id="preloader"></div> */}
    </>
  );
};
